import type React from 'react';
import { useCallback } from 'react';

import { ACTION_TYPE_SET_SERVICE_COLLECTION } from '../../../../settings/automation-rules/constants/action-types';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import type { PreconfiguredRule } from '../automation-playbook-types';
import { AutomationPlaybooks } from '../playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const RATE_SHOPPER_RULE: PreconfiguredRule = {
  active: true,
  isNew: true,
  isTemplate: true,
  playbook: AutomationPlaybooks.RateShopperByMarketplace,
  ruleName: messages.rateShopperRuleName,
  filterConditions: [{ fieldType: 'MarketplaceId', operator: 'includes', value: '', logicalOperator: 'AND' }],
  orderRuleActions: [{ actionTypeId: ACTION_TYPE_SET_SERVICE_COLLECTION, parameter: null, isDeleted: false }],
};

export const RateShopperRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const handleClick = useCallback(() => openRuleEditor(RATE_SHOPPER_RULE), [openRuleEditor]);

  return <PlaybookCard description={messages.rateShopperDescription} glyph='van' onClick={handleClick} title={messages.rateShopperTitle} />;
};
